import React, { useState, useEffect, useRef } from "react";
import axiosClient from "../../../utils/axiosClient";
import { urlAgendamentosPorDia } from "../../../utils/constants";
import { IonLabel } from "@ionic/react";
import Chart from "chart.js/auto";

export default function AgendamentosSemana({
  totalClientes,
  totalAgendamentos,
  dataBusca
}) {
  const chartRef = useRef(null);
  const [chart, setChart] = useState(null);

  const listaEmpresas = async () => {
    try {
      const response = await axiosClient.post(urlAgendamentosPorDia, {
        dia: dataBusca
      });
      totalClientes(response?.data?.total_clientes?.total);
      const somaTotalAgendamentos = response?.data?.agendamentos_semana
        ? response.data.agendamentos_semana.reduce(
            (acc, item) => acc + item.total,
            0
          )
        : 0;

      totalAgendamentos(somaTotalAgendamentos);
      if (response.data.agendamentos_semana) {
        const cores = ["#141458", "#000000", "#D2F660", "#4B66E3", "#E52730", "#F98715", "#B165C9"];
        const labels = response.data.agendamentos_semana.map(
          (item) => item.data
        );
        const data = response.data.agendamentos_semana.map(
          (item) => item.total
        );
        const backgroundColors = cores;

        updateChart(labels, data, backgroundColors);
      } else {
        throw new Error("No data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateChart = (labels, data, backgroundColors) => {
    if (chart) {
      chart.destroy();
    }

    const ctx = chartRef.current.getContext("2d");

    const newChart = new Chart(ctx, {
      type: "pie",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Agendamentos",
            data: data,
            backgroundColor: backgroundColors,
            barThickness: 25,
            borderRadius: 20,
          },
        ],
      },
      options: {
        indexAxis: "y",
        aspectRatio: 1,
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false,
              drawTicks: false,
            },
            ticks: {
              display: true,
              color: "#FFFFFF",
              drawTicks: false,
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              display: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
              color: "#FFFFFF",
              drawTicks: false,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    });
    setChart(newChart);
  };

  useEffect(() => {
    listaEmpresas();
    setTimeout(() => {}, 1000);
    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [dataBusca]);

  return (
    <div>
      <div>
        <IonLabel>
          <h2
            className="ion-text-center"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Agendamentos da Semana
          </h2>
        </IonLabel>
        <canvas
          id="myChart"
          ref={chartRef}
          style={{ width: "95%", height: "auto" }}
        ></canvas>
      </div>
    </div>
  );
}
